export default __webpack_public_path__ + "static/media/project1.e705b61f.jpg";